module.exports = __webpack_public_path__ + "452df7b16b4b91a69158617250b0e8e9.png";